import { render } from "./ContactPage.vue?vue&type=template&id=4fd24592&scoped=true"
const script = {}

import "./ContactPage.vue?vue&type=style&index=0&id=4fd24592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd24592"]])

export default __exports__